export default function SetUniqueIdentifierForWCF(): void {
    let retryCount = 0;

    function requestUniqueIdentifierForWCF(): void {
        if (retryCount++ === 10) {
            fetch('/legacy/Home/SetWCFUniqueIdentifierFailed', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            })
                .then((response) => {
                    console.error('Maximum retry attempts reached. UniqueIdentifierForWCF Request failed.');
                })
                .catch((error) => {
                    console.warn('Error in fetch: ', error);
                });
            return;
        }

        fetch('http://localhost:8850/Data', { headers: { 'Access-Control-Request-Private-Network': 'true' } })
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return await response.text();
            })
            .then((data) => {
                const wcfuid = data;
                fetch(`/legacy/Home/SetWCFUniqueIdentifier?WCFUID=${encodeURIComponent(wcfuid)}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                })
                    .then(async (response) => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return await response.json();
                    })
                    .then((data) => {
                        console.log('wcf uid set to ' + atob(wcfuid));
                    })
                    .catch((error) => {
                        console.warn('Error in fetch: ', error);
                    });
            })
            .catch((error) => {
                console.warn('Error in fetch: ', error);
                setTimeout(requestUniqueIdentifierForWCF, 30000);
            });
    }
    requestUniqueIdentifierForWCF();
}
